export default "__VITE_ASSET__BA46p_bt__"